import { render } from "./data-maintain.vue?vue&type=template&id=2b98156e&scoped=true"
import script from "./data-maintain.vue?vue&type=script&lang=js"
export * from "./data-maintain.vue?vue&type=script&lang=js"

import "./data-maintain.vue?vue&type=style&index=0&id=2b98156e&scoped=true&lang=css"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b98156e"]])

export default __exports__